module.exports = __webpack_public_path__ + "img/ic-left-blue.297df520.svg";